import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full font-poppins font-medium">
      {/* Tier 1: Top Bar - Socials & News & Offers */}
      <div className="bg-[#1e293b] text-white py-6 border-b border-white/10 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
          
          {/* Socials Group */}
          <div className="flex items-center gap-6">
            <div className="flex flex-col border-r border-white/20 pr-6 text-left">
              <span className="text-[10px] uppercase tracking-widest text-white/70 leading-tight">Get In</span>
              <span className="text-xl font-black leading-tight uppercase">Touch</span>
            </div>
            <div className="flex gap-5 text-xl text-white/80">
              <a href="#" className="hover:text-syana-blue-400 transition-colors"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="#" className="hover:text-syana-blue-400 transition-colors"><i className="fa-brands fa-linkedin-in"></i></a>
              <a href="#" className="hover:text-syana-blue-400 transition-colors"><i className="fa-brands fa-instagram"></i></a>
              <a href="#" className="hover:text-syana-blue-400 transition-colors"><i className="fa-brands fa-youtube"></i></a>
              <a href="#" className="hover:text-syana-blue-400 transition-colors"><i className="fa-brands fa-tiktok"></i></a>
            </div>
          </div>

          {/* Newsletter Form */}
          {/* Direct Connection Replacement */}
          <div className="flex flex-col lg:flex-row items-center gap-8 flex-1 justify-end">
            <div className="text-center lg:text-right hidden md:block">
              <span className="text-[10px] uppercase tracking-[0.4em] text-white/50 font-black leading-tight block">Vision Excellence</span>
              <span className="text-sm lg:text-lg font-black uppercase tracking-widest text-[#d4af37]">Since 1996</span>
            </div>
            <div className="h-10 w-[1px] bg-white/10 hidden lg:block mx-4"></div>
            <a 
              href="https://wa.me/94117575100" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-4 bg-white/5 hover:bg-white border border-white/10 hover:border-white rounded-xl px-10 py-4 transition-all duration-500 group"
            >
              <div className="w-8 h-8 lg:w-10 lg:h-10 bg-syana-blue-600 rounded-full flex items-center justify-center text-white text-sm lg:text-base group-hover:scale-110 transition-transform">
                <i className="fa-brands fa-whatsapp"></i>
              </div>
              <div className="text-left">
                <span className="text-[9px] uppercase tracking-[0.3em] text-white/50 group-hover:text-slate-500 block">Direct Support</span>
                <span className="text-xs lg:text-sm font-black uppercase tracking-widest group-hover:text-slate-900">+94 11 75 75 100</span>
              </div>
            </a>
          </div>

        </div>
      </div>

      {/* Tier 2: Navigation Menu Bar */}
      <div className="bg-[#020617] py-6 px-6 overflow-x-auto whitespace-nowrap">
        <div className="max-w-4xl mx-auto">
          <ul className="flex justify-center items-center gap-8 lg:gap-12 text-[10px] lg:text-xs font-black uppercase tracking-[0.2em] text-white/70">
            <a href="#hero" className="hover:text-white cursor-pointer transition-colors">Home</a>
            <a href="#about" className="hover:text-white cursor-pointer transition-colors">About</a>
            <a href="#services" className="hover:text-white cursor-pointer transition-colors">Services</a>
            <a href="#products" className="hover:text-white cursor-pointer transition-colors">Products</a>
            <li className="hover:text-white cursor-pointer transition-colors">Contact</li>
          </ul>
        </div>
      </div>

      {/* Tier 3: Contact Section with Background Overlay */}
      <div className="relative py-20 px-6 overflow-hidden">
        {/* Cinematic Background Image Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1543336337-df41865c3fd4?q=80&w=2070&auto=format&fit=crop" 
            alt="Eye care background" 
            className="w-full h-full object-cover grayscale opacity-20"
          />
          <div className="absolute inset-0 bg-[#0f172a] mix-blend-multiply"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 items-start text-center md:text-left">
            
            {/* Address */}
            <div className="space-y-4">
              <h4 className="text-white text-xs lg:text-sm font-black uppercase tracking-[0.3em] opacity-80">Address</h4>
              <div className="text-white/60 text-xs lg:text-sm space-y-2 font-medium">
                <p>Siyane Optometrists Corporate Office</p>
                <p>No. 06, Ward Place, Colombo 07</p>
              </div>
            </div>

            {/* Telephone */}
            <div className="space-y-4">
              <h4 className="text-white text-xs lg:text-sm font-black uppercase tracking-[0.3em] opacity-80">Telephone</h4>
              <a href="tel:+94117575100" className="text-white/60 text-xs lg:text-sm font-medium hover:text-white transition-colors decoration-white/20 underline underline-offset-8 block">+94 11 75 75 100</a>
            </div>

            {/* Fax */}
            <div className="space-y-4">
              <h4 className="text-white text-xs lg:text-sm font-black uppercase tracking-[0.3em] opacity-80">Fax</h4>
              <span className="text-white/60 text-xs lg:text-sm font-medium block">+94 11 26 99 322</span>
            </div>

            {/* Email */}
            <div className="space-y-4">
              <h4 className="text-white text-xs lg:text-sm font-black uppercase tracking-[0.3em] opacity-80">Email</h4>
              <a href="mailto:info@siyaneoptom.lk" className="text-white/60 text-xs lg:text-sm font-medium hover:text-white transition-colors decoration-white/20 underline underline-offset-8 block">info@siyaneoptom.lk</a>
            </div>

          </div>

          <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] uppercase tracking-widest text-white/30">
            <p>© {new Date().getFullYear()} Siyane Optometrists. All Rights Reserved.</p>
            <div className="flex gap-8">
              <Link to="/privacy-policy" className="hover:text-white cursor-pointer transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-white cursor-pointer transition-colors">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
